import { Component } from "@angular/core";

@Component({
  selector: "app-trees-and-shrubs-felling-with-decision-request",
  templateUrl:
    "./trees-and-shrubs-felling-with-decision-request.component.html",
  standalone: false,
})
export class TreesAndShrubsFellingWithDecisionRequestComponent {}
